<sh-modal
  *ngIf="open"
  [visible]="open"
  sticky="true"
  id="licenseModal"
  modal-width="80%"
  modal-height="60%"
  class="modal-container"
>
  <sh-text slot="header">
    <sh-text size="header-1">
      License Activation: Unlock Full Access Instantly
      <sh-icon
        button
        icon="cancel"
        class="close-button"
        size="s"
        (click)="closeModal()"
      ></sh-icon>
    </sh-text>
  </sh-text>

  <div class="modal-content two-column-layout">
    <div class="modal-column">
      <sh-text size="header-2">Workflow Education</sh-text>
      <ul class="instruction-list">
        <li><sh-text size="body-1">Log in to the <strong>ExpertGuidance</strong> application using your credentials.</sh-text></li>
        <li><sh-text size="body-1">From the home screen, click <strong>"Launch"</strong> under the <strong>Workflow Education</strong> section.</sh-text></li>
        <li><sh-text size="body-1">The <strong>Workflow Guide Selection</strong> page will open.</sh-text></li>
        <li><sh-text size="body-1">You’ll see a list of workflows assigned to you.</sh-text></li>
        <li><sh-text size="body-1">Each workflow displays its <strong>license expiry date</strong> on the right-hand side.</sh-text></li>
        <li><sh-text size="body-1">
          To extend a workflow license, contact:
          <a href="mailto:ies-support.func@siemens-healthineers.com" style="color: #5E1EBE;"><strong>ies-support.func&#64;siemens-healthineers.com</strong></a></sh-text>
        </li>
        <li><sh-text size="body-1">Click <strong>"Launch"</strong> under any assigned workflow to begin immersive training.</sh-text></li>
      </ul>
    </div>

    <div class="modal-column">
      <sh-text size="header-2">Equipment Education</sh-text>
      <ul class="instruction-list">
        <li><sh-text size="body-1">Log in to the <strong>ExpertGuidance</strong> application using your credentials.</sh-text></li>
        <li><sh-text size="body-1">From the home screen, click <strong>"Launch"</strong> under the <strong>Equipment Education</strong> section.</sh-text></li>
        <li><sh-text size="body-1">The <strong>Equipment Selection</strong> page will open.</sh-text></li>
        <li><sh-text size="body-1">You’ll see a list of equipments assigned to you.</sh-text></li>
        <li><sh-text size="body-1">Each equipment displays its <strong>license expiry date</strong> on the right-hand side.</sh-text></li>
        <li><sh-text size="body-1">
          To extend a equipment license, contact:
          <a href="mailto:ies-support.func@siemens-healthineers.com" style="color: #5E1EBE;"><strong>ies-support.func&#64;siemens-healthineers.com</strong></a></sh-text>
        </li>
        <li><sh-text size="body-1">Click <strong>"Launch"</strong> under any assigned equipment to begin immersive training.</sh-text></li>
      </ul>
    </div>
  </div>
</sh-modal>
